var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.visible)?_c('div',{staticClass:"clienteleServicesDialog"},[_c('i',{staticClass:"el-icon-close qd-dialog__close qd-dialog__headerbtn",on:{"click":_setup.close}}),_c('iframe',{staticClass:"clienteleServicesDialog__iframe",attrs:{"src":_setup.src,"width":"100%","height":"100%","frameborder":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }